export { default } from "./SpotlightArticle";
